import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import DataTableAvisTest from "./DataTableAvisTest"
import AddTestLibre from "./AddTestLibre"
import TestEmploi from "./TestEmploi"

const AvisTest = props => {
  const [section, setSection] = useState(1)
  const [name, setName] = useState("")

  const back = () => {
    setSection(1)
  }

  // Récupération ID depuis l'URL
  const url = window.location.href
  const array = url.split("/")
  const id = array[4]

  // ⚠️ Correction: mise à jour du nom sans provoquer un re-render infini
  useEffect(() => {
    if (id === "1") {
      setName("test")
    } else {
      setName("DS")
    }
  }, [id])

  const renderBlock = section => {
    if (section === 1) {
      return <DataTableAvisTest />
    } else if (section === 2) {
      return <TestEmploi setSection={setSection} back={back} type={id} />
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{name}</title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 1,
                  })}
                  onClick={() => setSection(1)}
                >
                  {name}
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 2,
                  })}
                  onClick={() => setSection(2)}
                >
                  {props.t("Ajouter ")} {name} {props.t("pendant la séance")}
                </NavLink>
              </NavItem>
            </Nav>

            <Card>
              <CardBody>{renderBlock(section)}</CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

AvisTest.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(AvisTest))
